<div class="dashed-content" [class.highlight]="highlight">
  <ng-content> </ng-content>
</div>
